import { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './OrganizationTextBlockEditPage.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import { RichTextBlockResponseDto } from '../../../store/buyerAPI/block/dto/response/rich-text-block-response.dto';
import {
  fetchBlocks,
  fetchRichTextBlockById,
  updateRichTextBlock,
} from '../../../store/buyerAPI/block/reducers/block.slice';
import { RichTextBlockUpdateRequestDto } from '../../../store/buyerAPI/block/dto/request/rich-text-block-update-request.dto';
import { OrganizationTextBlockEditTemplate } from '../../templates';

interface OrganizationTextBlockEditPageProps {}

const OrganizationTextBlockEditPage: FC<
  OrganizationTextBlockEditPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { organizationId, blockId } = useParams();
  const navigate = useNavigate();
  const [textBlock, setTextBlock] = useState<RichTextBlockResponseDto>();

  const { richTextBlockStatus: status } = useSelector(
    (state: RootState) => state.blockSlice
  );

  useEffect(() => {
    if (blockId) {
      dispatch(fetchRichTextBlockById(blockId))
        .unwrap()
        .then((resp) => setTextBlock(resp));
    }
  }, [dispatch, blockId]);

  const handleOnChange = (textBlock: RichTextBlockResponseDto) => {
    setTextBlock(textBlock);
  };

  const callbackFn = async (textBlock: RichTextBlockResponseDto) => {
    const textBlockToUpdate: RichTextBlockUpdateRequestDto = {
      content: textBlock.content,
      blockType: textBlock.blockType,
      organizationId: textBlock.organizationId,
      id: textBlock.id,
      published: textBlock.published,
    };
    await dispatch(updateRichTextBlock(textBlockToUpdate));
    dispatch(fetchBlocks(organizationId!));
    navigate(`/organizations/edit/${organizationId}/content-blocks`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {textBlock && (
        <div className={cn(styles.wrapper)}>
          <OrganizationTextBlockEditTemplate
            handleOnChange={handleOnChange}
            textBlock={textBlock}
            callbackFn={callbackFn}
          />
        </div>
      )}
    </>
  );
};

export default OrganizationTextBlockEditPage;
